import React, { useEffect } from 'react';
import { View, StyleSheet, } from 'react-native';
import Animated, { cancelAnimation, Easing, runOnJS, useAnimatedStyle, useSharedValue, withTiming, } from 'react-native-reanimated';
import { rem } from 'design-system/values';
const yShift = rem(12);
const source = require('../img/notification.png');
const AnimatedIconBell = ({ isFetching, onSettled, style, tintColor, }) => {
    const sharedValue = useSharedValue(0);
    const rotationStyle = useAnimatedStyle(() => {
        const arc = (sharedValue.value + 30) % 120;
        const rotate = Math.abs(arc - 60) - 30;
        return {
            transform: [
                { translateY: -yShift },
                { rotateZ: `${rotate}deg` },
                { translateY: yShift },
            ],
        };
    });
    useEffect(() => {
        sharedValue.value = withTiming(isFetching ? 540 : 0, {
            duration: 3000,
            easing: Easing.out(Easing.exp),
        }, (finished) => {
            if (finished && onSettled)
                runOnJS(onSettled)();
        });
        return () => cancelAnimation(sharedValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFetching]);
    return (<View style={style}>
      <Animated.Image tintColor={tintColor} source={source} style={[styles.image, rotationStyle]}/>
    </View>);
};
const styles = StyleSheet.create({
    image: {
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default AnimatedIconBell;
